import * as Yup from 'yup';

export const ContactsSchema = Yup.object().shape({
  storageMode: Yup.string().required('Select a contact storage mode'),
});

export interface ContactsDataType {
  storageMode: string;
}

export const ContactsInitialValues: ContactsDataType = {
  storageMode: '',
};

export interface ContactsInterface {
  storageMode: string;
}
